// extracted by mini-css-extract-plugin
export default {"login":"LoginForm_login__Z5tJN","content":"LoginForm_content__Tr1a-","submit":"LoginForm_submit__6vtqO"};